// WEB 2.0 GLOBAL JS



$( document ).ready(function() {
console.log("BDJ Global Ready");

// APPENDS

$(".index .featured_collections .thumbnail .info").append('<div class="action_button action_button--has-outline action_button--is-rounded action_button--has-text-shadow action_button--is-bevel">VIEW COLLECTION</div>');


$(".index .slideshow__gallery-cell-slide-4 a").attr("rel", "modal:open");


	// PAUSE VIDEO ON MODAL CLOSE
	$(".video-modal a").mousedown(function() { 
		console.log("triger close");
		$('.video-modal video').trigger('pause');
	});





// PANT VARIANT V TAILOR FIX

$(".fit-detector #prodPageGetFit").click(function(){
	localStorage.setItem("prodReturnURL", window.location.href);
	 console.log("Return URL: "+ localStorage.getItem("prodReturnURL"));
});







});